import { Injectable } from '@angular/core';
import { DataService } from 'app/shared/services/data.service';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { Observable } from 'rxjs';
import { IResult } from 'app/shared/models/result.model';
import { map } from 'rxjs/operators';
import { IDtoProduct } from 'app/shared/models/position/dto-product.model';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { IDtoCalculateSalary } from 'app/shared/models/position/dto-calculate-salary.model';
import { IDtoPosition } from 'app/shared/models/position/dto-position.model';
import { IDtoCustomerCommission } from 'app/shared/models/position/dto-customer-commission.model';

@Injectable()
export class PositionService {
    private quoteUrl = '';
    constructor(private service: DataService, private configurationService: ConfigurationService) {
        if (this.configurationService.isReady) {
            this.quoteUrl = this.configurationService.serverSettings.quoteUrl;
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
                this.quoteUrl = this.configurationService.serverSettings.quoteUrl;
            });
        }
    }
    public getProducts(): Observable<IResult> {
        const url = `${this.quoteUrl}api/Products/getProducts`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogProductJobs(): Observable<IDtoCatalog[]> {
        const url = `${this.quoteUrl}api/Products/getCatalogProductJobs`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public updateProduct(dto: IDtoProduct): Observable<IResult> {
        const url = `${this.quoteUrl}api/Products/updateProduct`;
        return this.service.putWithId(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public addProduct(dto: IDtoProduct): Observable<IResult> {
        const url =`${this.quoteUrl}api/Products/addProduct`;
        return this.service.post(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public getCatalogProductTypes(): Observable<IDtoCatalog[]> {
        const url = `${this.quoteUrl}api/ProductTypes/getCatalogProductTypes`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogPositionStatus(): Observable<IDtoCatalog[]> {
        const url = `${this.quoteUrl}api/PositionStatus/getCatalogPositionStatus`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogPayrollTypes(): Observable<IDtoCatalog[]> {
        const url = `${this.quoteUrl}api/PayrollTypes/getCatalogPayrollTypes`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogIsrTypes(): Observable<IDtoCatalog[]> {
        const url = `${this.quoteUrl}api/IsrTypes/getCatalogIsrTypes`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogWorkdayTypes(): Observable<IDtoCatalog[]> {
        const url = `${this.quoteUrl}api/WorkdayTypes/getCatalogWorkdayTypes`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogPaymentForms(): Observable<IDtoCatalog[]> {
        const url = `${this.quoteUrl}api/PaymentForms/getCatalogPaymentForms`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogPositionTypes(): Observable<IDtoCatalog[]> {
        const url = `${this.quoteUrl}api/PositionTypes/getCatalogPositionTypes`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogProductExpenses(): Observable<IDtoCatalog[]> {
        const url = `${this.quoteUrl}api/Products/getCatalogProductExpenses`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getClasifications(): Observable<IResult> {
        const url = `${this.quoteUrl}api/Clasifications/getClasifications`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getPaymentConcepts(): Observable<IResult> {
        const url = `${this.quoteUrl}api/PaymentConcepts/getPaymentConcepts`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getMinimumSalary(): Observable<IResult> {
        const url = `${this.quoteUrl}api/MinimumSalaries/getMinimumSalary`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public calculateSalary(dto: IDtoCalculateSalary): Observable<IResult> {
        const url =`${this.quoteUrl}api/PositionCalculations/calculateSalary`;
        return this.service.post(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public addPosition(dto: IDtoPosition): Observable<IResult> {
        const url =`${this.quoteUrl}api/Positions/addPosition`;
        return this.service.post(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public updatePosition(dto: IDtoPosition): Observable<IResult> {
        const url =`${this.quoteUrl}api/Positions/updatePosition`;
        return this.service.putWithId(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public getPositionsByFilter(customerId: number): Observable<IResult> {
        const url = `${this.quoteUrl}api/Positions/getPositionsByFilter?customerId=${customerId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getPosition(positionId: number): Observable<IResult> {
        const url = `${this.quoteUrl}api/Positions/getPosition?positionId=${positionId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public deleteCommission(id: number): Observable<IResult> {
        const url =`${this.quoteUrl}api/Commissions/deleteCommission?id=${id}`;
        return this.service.delete(url).pipe(map((response: any) => {
            return response;
        }));
    }
    public deleteVoucher(id: number): Observable<IResult> {
        const url =`${this.quoteUrl}api/Vouchers/deleteVoucher?id=${id}`;
        return this.service.delete(url).pipe(map((response: any) => {
            return response;
        }));
    }
    public getCatalogPositionsByCustomerId(customerId: number): Observable<IDtoCatalog[]> {
        const url = `${this.quoteUrl}api/Positions/getCatalogPositionsByCustomerId?customerId=${customerId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getPositionsByCustomerId(customerId: number): Observable<IResult> {
        const url = `${this.quoteUrl}api/Positions/getPositionsByCustomerId?customerId=${customerId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getPositionsByProjectId(projectId: number): Observable<IResult> {
        const url = `${this.quoteUrl}api/Positions/getPositionsByProjectId?projectId=${projectId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public updatePositionMasiveByCustomer(dto: IDtoCatalog): Observable<IResult> {
        const url =`${this.quoteUrl}api/Positions/updatePositionMasiveByCustomer`;
        return this.service.putWithId(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public getCustomerCommissionsByCustumerId(customerId: number): Observable<IResult> {
        const url = `${this.quoteUrl}api/CustomerCommissions/getCustomerCommissionsByCustumerId?customerId=${customerId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public addCustomerCommission(dto: IDtoCustomerCommission): Observable<IResult> {
        const url =`${this.quoteUrl}api/CustomerCommissions/addCustomerCommission`;
        return this.service.post(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public updateCustomerCommission(dto: IDtoCustomerCommission): Observable<IResult> {
        const url = `${this.quoteUrl}api/CustomerCommissions/updateCustomerCommission`;
        return this.service.putWithId(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public getCatalogFixedCustomerCommissionsByCustomerId(customerId: number): Observable<IDtoCatalog[]> {
        const url = `${this.quoteUrl}api/CustomerCommissions/getCatalogFixedCustomerCommissionsByCustomerId?customerId=${customerId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogVariableCustomerCommissionsByCustomerId(customerId: number): Observable<IDtoCatalog[]> {
        const url = `${this.quoteUrl}api/CustomerCommissions/getCatalogVariableCustomerCommissionsByCustomerId?customerId=${customerId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public updatePositionMasiveByProject(dto: IDtoCatalog): Observable<IResult> {
        const url =`${this.quoteUrl}api/Positions/updatePositionMasiveByProject`;
        return this.service.putWithId(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
}